
import { cn } from "@/lib/utils";

const statusConfig = {
  active: {
    color: "bg-success-muted text-success-muted-foreground",
    label: "Active",
    dotColor: "bg-success"
  },
  inactive: {
    color: "bg-destructive/10 text-destructive",
    label: "Inactive",
    dotColor: "bg-destructive"
  },
  pending: {
    color: "bg-warning-muted text-warning-muted-foreground",
    label: "Pending",
    dotColor: "bg-warning"
  },
  scheduled: {
    color: "bg-info-muted text-info-muted-foreground",
    label: "Scheduled",
    dotColor: "bg-info"
  },
  unenrolled: {
    color: "bg-destructive/10 text-destructive",
    label: "Unenrolled",
    dotColor: "bg-destructive"
  }
};

const StatusBadge = ({ status }: { status?: string | null }) => {
  // Normalize status to lowercase and check if it exists in our config
  const normalizedStatus = (status || 'inactive').toLowerCase();
  const statusKey = Object.keys(statusConfig).find(key => 
    key === normalizedStatus
  ) as keyof typeof statusConfig || 'inactive';
  
  const config = statusConfig[statusKey];

  return (
    <span className={cn(
      "px-3 py-1 rounded-full text-xs font-medium inline-flex items-center gap-1.5",
      config.color
    )}>
      <span className={`h-1.5 w-1.5 rounded-full ${config.dotColor}`}></span>
      {config.label}
    </span>
  );
};

export default StatusBadge;
